import { Card } from '@latitude/card';
import { FormInput, FormSelect, useFormContext } from '@latitude/form';
import type { SelectOption } from '@latitude/select';
type Props = {
  countryOptions: SelectOption[];
  isCountryOptionsLoading: boolean;
};
function OrganizationDetailsContent({
  countryOptions,
  isCountryOptionsLoading
}: Props) {
  const {
    control
  } = useFormContext();
  return <Card className="w-full flex flex-col gap-6" data-sentry-element="Card" data-sentry-component="OrganizationDetailsContent" data-sentry-source-file="OrganizationDetailsContent.tsx">
      <FormInput control={control} name="organizationName" label="Organization legal name" inputSize="medium" data-sentry-element="FormInput" data-sentry-source-file="OrganizationDetailsContent.tsx" />
      <FormSelect control={control} name="organizationCountry" label="Country of incorporation" options={countryOptions} optional={false} loading={isCountryOptionsLoading} data-sentry-element="FormSelect" data-sentry-source-file="OrganizationDetailsContent.tsx" />
    </Card>;
}
export { OrganizationDetailsContent };